import { isVerticalWritingMode } from "./isVerticalWritingMode";

export const applyStyles = (scrollPosition, apply) => {
  const styles = {
    blockSize: "100dvb",
    insetInlineStart: "0",
    position: "fixed",
    insetBlockStart: isVerticalWritingMode()
      ? `${scrollPosition}px`
      : `${scrollPosition * -1}px`,
    inlineSize: "100dvi"
  };
  Object.keys(styles).forEach((key) => {
    document.body.style[key] = apply ? styles[key] : "";
  });
};
